import React, { useEffect, useState } from "react";
import { Card, Table, Button, Space, message } from "antd";
import { Dropdown } from "antd";
import { DeleteOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import { isArrayNonEmpty, isValidElement } from "../../util/ApiHelper";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { BASE_API_CONFIG, axiosInstance } from "../../util/Api";
import EnquiryStatusTags from "../enquiries/EnquiriesStatus";
import FilterButton from "../../components/FilterButton/FilterButton";
import ListEmptyComponent from "../../components/ListEmptyComponent/ListEmptyComponent";


let navigateToDetails;
let deleteById;

const formatDate = (createdAt) => {
  return new Date(createdAt).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const columns = [
  {
    title: "Company Type",
    key: "Company Type",
    render: (record) => <div>{record?.companyType}</div>,
  },
  {
    title: "Company Name",
    key: "Company Name",
    render: (record) => <div>{record?.companyName}</div>,
  },
  {
    title: "Email",
    key: "Email",
    render: (record) => <div>{record?.email}</div>,
  },
  {
    title: "Mobile",
    key: "Mobile",
    render: (record) => <div>{record?.mobile}</div>,
  },
  {
    title: "Nature of Business",
    key: "Nature of Business",
    render: (record) => {
      return <div>{record?.natureOfBusiness}</div>;
    },
  },
  {
    title: "Actions",
    key: "actions",
    render: (record) => (
      <div className="myexim-action-icon" onClick={(e) => e.stopPropagation()}>
        <Dropdown
          menu={{
            items: [
              {
                label: "View Details",
                key: "1",
                icon: <EyeOutlined />,
                onClick: () => {
                  navigateToDetails(record?.id);
                },
              },
            ],
          }}
          trigger={["click"]}
        >
          <Space>
            <MoreOutlined />
          </Space>
        </Dropdown>
      </div>
    ),
  },
];

const PromotionsList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [registrationAdminData, setRegistrationAdminData] = useState(null);
  const { loading } = useSelector(({ common }) => common);

  const page = 1;
  const limit = 10;

  useEffect(() => {
    fetchExporterRegistration();
  }, [dispatch]);

  const onShowSizeChange = (current, pageSize) => {};

  const fetchExporterRegistration = async () => {
    try {
      dispatch(fetchStart());
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/registartion?page=1&limit=10`
      );
      const prom = response?.data?.data;
      setRegistrationAdminData(prom.rows);
    } catch (error) {
      console.error("Error fetching registartion:", error);
    } finally {
      dispatch(fetchSuccess());
    }
  };
  deleteById = async (id) => {
    try {
      const response = await axiosInstance.delete(
        `${BASE_API_CONFIG.baseURL}/registartion/${id}`
      );
      if (response.status === 200) {
        message.success("success", "Exporter Registration deleted");
        await fetchExporterRegistration();
      } else {
        message.error("error", "Failed to delete promotion");
      }
    } catch (error) {
      console.error("Error deleting registartion:", error);
    }
  };

  navigateToDetails = (id) => {
    if (isValidElement(id)) {
      history.push(`registrations/view?id=${id}`);
    } else {
      history?.push("registrations/add-edit");
    }
  };

  return (
    <Card
      title={
        <div style={{ display: "flex" }}>
          <div className="myexim-table-title">Exporter Registration</div>
        </div>
      }
    >
      <div>
        <div className="myexim-table-header">
          {/* <div>
              <Input
                placeholder="Search Exporter Registration"
                size="large"
                onChange={onSearch}
                suffix={<SearchOutlined />}
                onPressEnter={(e) => onSearch(e.target.value)}
              />
            </div> */}
          {/* <div>
            <Button type="primary" onClick={() => navigateToDetails()}>
              Add New Promotion
            </Button>
          </div> */}
        </div>
        {/* <FilterButton
          className={"rfq-filter-button"}
          availableStatus={Object.values(EnquiryStatus)}
          onSelectStatus={handleSelectStatus}
        /> */}
        {isArrayNonEmpty(registrationAdminData) ? (
          <Table
            rowClassName={(record, index) =>
              index % 2 === 0 ? "table-row-light" : "table-row-dark"
            }
            onRow={(record) => {
              return {
                onClick: (e) => {
                  if (
                    !e.target.classList.contains(
                      "ant-dropdown-menu-title-content"
                    )
                  ) {
                    navigateToDetails(record?.id);
                  }
                },
              };
            }}
            className="gx-table-responsive my-product-table myexim-table"
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={registrationAdminData}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              pageSize: 10,
              total: registrationAdminData?.count,
              onChange: onShowSizeChange,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        ) : (
          !loading && (
            <ListEmptyComponent
              message="No Exporter Registration found"
              onButtonClick={() => navigateToDetails()}
            />
          )
        )}
      </div>
    </Card>
  );
};

export default PromotionsList;
